"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformSimpleUsersToSelectOptions = void 0;
function transformSimpleUsersToSelectOptions(simpleUsers) {
    return simpleUsers.map((user) => ({
        label: `${user.fullName} <${user.email}>`,
        value: user._id,
    }));
}
exports.transformSimpleUsersToSelectOptions = transformSimpleUsersToSelectOptions;
//# sourceMappingURL=transformSimpleUsersToSelectOptions.js.map